import { Component } from '@angular/core';
import {MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef} from '@angular/material/dialog';
import {AvatarComponent} from '@shared/components/avatar/avatar.component';
import { PageResult } from '@core/model/pagination/page-result';
import { NotificationModel } from '@core/model/notification';
import { Subject } from 'rxjs';
import { NotificationService } from '@core/services/notification.service';
import { NotifyService } from '@core/services/notify.service';
import { AppUtilService } from '@shared/services/app-util.service';
import { Router } from '@angular/router';
import { NotificationTypes } from '@generated/queries';
import { CommonModule } from '@angular/common';
import { TimeAgoPipe } from "../../../../../shared/pipe/time-ago.pipe";
import { BkButton } from '@brickclay-org/ui';

@Component({
  selector: 'app-header-notification',
  imports: [
    MatDialogClose,
    MatDialogContent,
    MatDialogActions,
    BkButton,
    AvatarComponent,
    CommonModule,
    TimeAgoPipe
],
  templateUrl: './header-notification.component.html',
  standalone: true,
  styleUrl: './header-notification.component.css'
})
export class HeaderNotificationComponent {

 notifications: PageResult<NotificationModel> = new PageResult<
    NotificationModel
  >();
  loading: boolean;
  nextLoading: boolean;
  unsubscribe$: Subject<boolean> = new Subject();

  constructor(
    private dialogRef: MatDialogRef<HeaderNotificationComponent>,
    // private layout: LayoutService,
    public notificationService: NotificationService,
    private notifyService: NotifyService,
    private appUtilService: AppUtilService,
    private router: Router
  )
  {
     this.getNotifications();
  }


  async loadMoreNotifications() {
  this.nextLoading = true;
  const notifications = await this.notificationService.fetchNotifications(
    this.notifications?.data?.length
  );

  if (notifications?.data?.length) {
    const newItems = notifications.data.filter(notification =>
      !this.notifications.data.find(x => x.id === notification?.id) &&
      notification?.type === NotificationTypes.Alert 
    );

    // Create a new array instead of mutating the frozen one
    this.notifications = {
      ...this.notifications,
      data: [...this.notifications.data, ...newItems],
      pageInfo: notifications.pageInfo
    };
  }

  this.nextLoading = false;
  this.notificationService.notificationCount = this.notifications?.data?.length;
}


  async getNotifications() {
    this.loading = true;
    this.notifications = await this.notificationService.fetchNotifications(
      null
    );
    this.loading = false;
    this.notificationService.notificationCount = this.notifications?.data?.length;

    console.log("Notifications Data: ",this.notifications);
  }


  async markAsRead(id: string) {
    const result = await this.notificationService.markAsRead(id);
    if (result) {
      this.notifications.data = this.notifications.data.filter(
        (x) => x.id !== id
      );
      this.notifications.totalCount -= 1;
      this.notificationService.notificationCount = this.notifications?.data?.length;
    }
  }

  async markAllAsRead() {
    this.loading = true;
    const result = await this.notificationService.markAllAsRead(
      this.notifications.data.map((x) => x.id)
    );
    if (result) {
      await this.getNotifications();
    }
    this.loading = false;
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
  }

  redirect(notification: NotificationModel){
    this.router.navigateByUrl(this.appUtilService.getObjectUrl(notification));
  }

  cancel() {
    this.dialogRef.close();
  }

  getDate(date: Date) {
    var localDateTime = new Date(date);
    localDateTime.setMinutes(
      localDateTime.getMinutes() - localDateTime.getTimezoneOffset()
    );
    return localDateTime;
  }
  isRead(status: boolean){
    return status
  }
}
